module.exports = __webpack_public_path__ + "static/media/pet(16x16).75555fe3.ico";